export const i18nRequestInterceptor = (config) => {
  if (sessionStorage.getItem('WEB_LOCALE_LANGUAGE') || localStorage.getItem('WEB_LOCALE_LANGUAGE')) {
    config.headers['Accept-Language'] = (
      sessionStorage.getItem('WEB_LOCALE_LANGUAGE') || localStorage.getItem('WEB_LOCALE_LANGUAGE')
    ).replace(/_/g, '-')
  }
  return Promise.resolve(config)
}